function getMonthName(dateISO = null) {
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const d = dateISO ? new Date(dateISO) : new Date();
    return monthNames[d.getMonth()];
}

export default getMonthName;
